/**
 * Extracts the store name from a Shopify store URL.
 * For example, from 'https://coolthreads.myshopify.com/' it returns 'coolthreads'.
 * @param {string} url - The Shopify store URL.
 * @returns {string | null} - The extracted store name, or null if not found.
 */
export function extractStoreNameFromUrl(url: string): string | null {
    try {
        const { hostname } = new URL(url);
        const match = hostname.match(/^([^.]+)\.myshopify\.com$/);
        return match ? match[1] : null;
    } catch {
        return null;
    }
}
